import notifications from '@/services/api/internal/notifications.api';

export function getNotifications() {
  return notifications.getNotifications();
}

export function getUnreadNotifications() {
  return notifications.getNotifications({
    params: {
      q: {
        read: {
          $eq: 'N',
        },
      },
    },
  });
}

export function getCountNotifications() {
  return notifications.getCountNotifications().then((res) => res[0].unread);
}

export function checkNotifications(id, unread = false) {
  return unread
    ? notifications.checkNotifications(id)
    : notifications.checkNotifications(id, { read: 'O' });
}
